import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {VnaCampaignService} from '../../services/vna-campaign.service';
import {AuthService} from '../../../../../core/service/auth.service';

const SELECT_VNA_CAMPAIGN_VALUE_ACCESSOR: any = {
  multi: true,
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectVnaCallerIdCampaignComponent)
};

@Component({
  selector: 'app-select-vna-caller-id-campaign',
  template: `
      <ngx-select [items]="campaigns" [(ngModel)]="campaign" [optionValueField]="valueField" [optionTextField]="textField" (select)="selected($event)" allowClear="true">
          <ng-template ngx-select-option ngx-select-option-selected let-option let-text="text">
              {{ option.data.name }} <br />
          </ng-template>
      </ngx-select>
      `,
  styleUrls: ['./select-vna-caller-id-campaign.component.scss'],
  providers: [SELECT_VNA_CAMPAIGN_VALUE_ACCESSOR]
})
export class SelectVnaCallerIdCampaignComponent implements OnInit {

  @Input() valueField: string = 'pk';
  @Input() textField: string = 'name';
  @Output() campChanged = new EventEmitter();

  campaigns: Array<Object> = [];
  _campaign: number;

  constructor(private campHandler: VnaCampaignService, private auth: AuthService) { }

  ngOnInit() {
    this.campHandler.findCallerIdVerificationCampaigns().subscribe(
      (result) => {
        this.campaigns = result;
        this.filterCampaigns();
      }
    );
  }

  protected filterCampaigns(): void {
    const pkClient = this.auth.getClient();
    if(pkClient > 0){
      this.campaigns = this.campaigns.filter( (camp: any) => {
        return camp['client_pk'] === pkClient;
      })
    }
  }

  selected(value: any) {
    this.propagateChange(this._campaign);
  }


  get campaign(): any { return this._campaign; };

  set campaign(v: any) {
    this._campaign = v;
    this.campChanged.emit(v);
    this.propagateChange(this._campaign);
  }

  propagateChange = (_: any) => {};

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(value: any): void {
    this._campaign = value;
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/components/select-vna-caller-id-campaign/select-vna-caller-id-campaign.component.ts